import './OptionListItem.scss';

interface OptionListItemProps {
  text: string;
  onClick?: () => void;
  checked?: boolean;
  disabled?: boolean;
  buttonType?: 'radio' | 'checkbox';
}

export default function OptionListItem({
  text,
  onClick,
  checked = false,
  disabled = false,
  buttonType = 'radio',
}: OptionListItemProps) {
  return (
    <li
      className={`flex flex-row gap-4 option-list-item ${disabled ? 'disabled' : ''}`}
      onClick={!disabled ? onClick : undefined}
    >
      <input type={buttonType} className={`${buttonType}-button`} disabled={disabled} checked={checked} readOnly />
      <span>{text}</span>
    </li>
  );
}
